import { useEffect, useState } from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { app, db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import {
  FaUserCircle,
  FaSignOutAlt,
  FaChartLine,
} from "react-icons/fa";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth(app);

  const [userName, setUserName] = useState("User");

  useEffect(() => {
    const loadUser = async () => {
      // Admin Pages
      if (
        location.pathname.includes("admin") ||
        location.pathname.includes("add-call") ||
        location.pathname.includes("edit-call") ||
        location.pathname.includes("manage-customers")
      ) {
        setUserName("Admin");
        return;
      }

      // Customer Pages
      const email = localStorage.getItem("customerEmail");

      if (!email) {
        setUserName("Customer");
        return;
      }

      const snapshot = await getDocs(collection(db, "customers"));

      let customerFound = false;

      snapshot.forEach((doc) => {
        const data = doc.data();

        if (
          data.email?.toLowerCase().trim() ===
          email.toLowerCase().trim()
        ) {
          setUserName(data.name || "Customer");
          customerFound = true;
        }
      });

      if (!customerFound) {
        setUserName("Customer");
      }
    };

    loadUser();
  }, [location]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.log("Logout error:", error);
    }

    localStorage.removeItem("adminEmail");
    localStorage.removeItem("customerEmail");

    navigate("/");
  };

  return (
    <Navbar
      expand="lg"
      style={{
        background: "#0f172a",
        padding: "12px 0",
      }}
      variant="dark"
    >
      <Container>
        <Navbar.Brand
          onClick={() => navigate("/")}
          style={{
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "24px",
          }}
        >
          <FaChartLine className="me-2 text-success" />
          Trading Wealth
        </Navbar.Brand>

        <Navbar.Toggle />

        <Navbar.Collapse>
          <Nav className="me-auto">
            {(location.pathname.includes("admin") ||
              location.pathname.includes("add-call") ||
              location.pathname.includes("edit-call") ||
              location.pathname.includes("manage-customers")) && (
              <>
                <Nav.Link
                  active={location.pathname === "/admin-dashboard"}
                  onClick={() => navigate("/admin-dashboard")}
                >
                  Dashboard
                </Nav.Link>

                <Nav.Link
                  active={location.pathname === "/manage-customers"}
                  onClick={() => navigate("/manage-customers")}
                >
                  Customers
                </Nav.Link>
              </>
            )}
          </Nav>

          <Nav className="ms-auto align-items-center">
            <Navbar.Text className="me-4 text-white">
              <FaUserCircle className="me-2" />
              {userName}
            </Navbar.Text>

            <Nav.Link
              onClick={handleLogout}
              style={{
                color: "#ff6b6b",
                fontWeight: "bold",
              }}
            >
              <FaSignOutAlt className="me-2" />
              Logout
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;